export default __webpack_public_path__ + "static/media/logo.54803e9b.svg";